module.exports = __webpack_public_path__ + "static/img/store_a.abcd6e4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/store_a.png
// module id = WFMD
// module chunks = 1